<template>

  <div class="feedItem panel bg-lightest black pb-0 px-0">
    <div class="w-100 px-5 font-weight-600">
      <span class="ml-1">Missing Check-ins</span>
    </div>

    <div class="mx-5 d-flex flex-columns justify-content-between mt-3 pb-3 border-bottom-light">
      <v-select class="pr-2" label="name" placeholder="Products" v-model="selectedProduct" :options="products"></v-select>
      <v-select class="" label="name" placeholder="Time" v-model="selectedHour" :options="hours"></v-select>
    </div>

    <div class="mx-5 search mt-3 d-flex flex-row justify-content-between">
        <input class="m-0 p-0 col" type="text" v-model="searchQuery" placeholder="Search for ticket or customer…">
        <i class="ico-search larger color-1 m-0 p-0 pl-2 col-sm-auto"></i>
    </div>

    <div class="px-5 pt-4 d-flex h-100">

      <list class="w-100 missingCheckinsList" :header="header" :body="body" :rows="filteredList" :actions="actions"></list>

    </div>

    <div class="color-6 text-center p-2 mt-2 border-light font-weight-600 pointer">
      <router-link :to="{ name: 'reservations' }" class="color-6">Go to reservations list</router-link>
    </div>
  </div>

</template>

<script>
import List from '@/tools/list/baseList'
import extendedVSelect from '@/extends/vue-select'


export default {

  data: function() {
    return {
        products:[
          'All Products',
          'Caves & Coastline',
          'Parasailling',
          'Sunset Beach Barbecue',
          'Sunset Beach Party'
        ],
        selectedProduct:'All Products',
        hours:[
          'Today',
          '9:00',
          '10:00',
          '11:00',
          '12:00',
          '13:00',
          '14:00',
        ],
        selectedHour: '10:00',
        searchQuery: '',
        rows:[
          {
            'time':'10:00',
            'product': 'Caves & Coastline',
            'customername': 'Gloria Nguyen',
            'reservationnr': 'CC12311',
            'pax': '8'
          },
          {
            'time':'10:30',
            'product': 'Caves & Coastline',
            'customername': 'Sven Mill',
            'reservationnr': 'CC12318',
            'pax': '8'
          },
          {
            'time':'10:30',
            'product': 'Beach Barbecue',
            'customername': 'Daniel Palmer',
            'reservationnr': 'CC12312',
            'pax': '2'
          },
          {
            'time':'12:20',
            'product': 'Parasailling',
            'customername': 'Frank Rivera',
            'reservationnr': 'CC12313',
            'pax': '4'
          },
          {
            'time':'14:00',
            'product': 'Sunset Beach Party',
            'customername': 'Alan Jackson',
            'reservationnr': 'CC12314',
            'pax': '2'
          },
          {
            'time':'14:30',
            'product': 'Parasailling',
            'customername': 'Fred Stinson',
            'reservationnr': 'CC12315',
            'pax': '2'
          },
          {
            'time':'14:40',
            'product': 'Caves & Coastline',
            'customername': 'Marta Hellen',
            'reservationnr': 'CC12316',
            'pax': '2'
          },
          {
            'time':'15:25',
            'product': 'Sunset Beach Party',
            'customername': 'António Fonseca',
            'reservationnr': 'CC12317',
            'pax': '2'
          }
        ],
        header: {
            selection: {
                active: false,
                event: function(event) {}
            },
            list: {
              'time':'Time',
              'product':'Product',
              'customername':'Customer Name',
              'reservationnr':'Reservation Nr',
              'pax': 'PAX'
            },
        },
        body: {
            selection: {
                active: false,
                event: function(event) {}
            },
            customRowEvent: this.sharedRowEvent,
            customCells: null,
        },
        actions: {
            label : 'Actions',
            list: [],
        }
    }
  },
  props: {
    cardInfo: {
      type: Object
    }
  },
  created: function() {
      var vm = this;

      // Base data

      //this.header.list = this.getReservationsLabels;

      // Custom cells

      this.body.customCells = {
      };

      // List actions

      //this.actions.list = this.sharedActions;
  },
  computed: {
    filteredList: function(){
      //filter time
      var selectedTime = this.selectedHour
      var fitleredRows = this.rows.filter(function(row){
        if(selectedTime == 'Today'){
          return true
        } else {
          //convert selectedTime to Date
          var selectedTimeArr = selectedTime.split(':');
          var selectedTimeDate = new Date();
          selectedTimeDate.setHours(selectedTimeArr[0]);
          selectedTimeDate.setMinutes(selectedTimeArr[1]);

          //convert row time to Date
          var rowTimeArr = row.time.split(':');
          var rowTime = new Date();
          rowTime.setHours(rowTimeArr[0]);
          rowTime.setMinutes(rowTimeArr[1]);

          return rowTime >= selectedTimeDate
        }
      });

      //filter product
      var selectedProduct = this.selectedProduct;
      fitleredRows = fitleredRows.filter(function(row){
        if(selectedProduct == 'All Products'){
          return true;
        } else {
          return row.product == selectedProduct;
        }
      });


      //filter product
      var searchQuery = this.searchQuery;
      fitleredRows = fitleredRows.filter(function(row){
        if(searchQuery == ''){
          return true;
        } else {
          return row.customername.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1  || row.reservationnr.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;
        }
      });

      return fitleredRows;
    }
  },
  components: {
      List,
      vSelect: extendedVSelect
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  .feed .feedItem{
    height: auto !important;
  }


  .search {
      padding: 0.5rem 0.75rem;
      display: flex;
      align-items: center;
      font-size: 0.8rem;
      border: 1px solid #e6eaee;
      background: #f5f8fa;

      > input {
          border: 0;
          background-color: transparent;
      }
  }

</style>

<style>
/* this a not pretty way to change the table head font size that is located on another component*/
.missingCheckinsList th span{font-size: 0.7rem;}
</style>



// WEBPACK FOOTER //
// FeedcardMissedcheckins.vue?b1449208